import { useCallback } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import CardSelectable from 'fe-design-base/organisms/CardSelectable';

import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { useTrackUx, withUxRoot } from 'util/uxEvents';

import { formatPartnerName } from './helpers';

export interface PartnerWidget {
  name: string;
  price: number;
  boostDuration: number;
  show: boolean;
}
interface TransactionWidgetProps {
  partnerName: string;
  onClick: (partnerName: string) => void;
  price: number;
  boosted: boolean;
  selected: string | null;
  leftContent?: React.ReactNode;
}

function TransactionWidget({
  partnerName,
  onClick,
  price,
  boosted,
  selected,
  leftContent,
}: TransactionWidgetProps) {
  const trackUx = useTrackUx();

  const handleClick = useCallback(() => {
    if (boosted) return;
    trackUx(EVENT_ACTIONS.RADIO_BUTTON_CLICKED, TRACK_ACTION_TYPES.CLICK, {
      button_text: 'boost_job_post',
      current_selection: partnerName,
    });
    onClick(partnerName);
  }, [boosted, trackUx, onClick, partnerName]);
  return (
    <CardSelectable
      w="100%"
      maxw="100%"
      pv={16}
      title={formatPartnerName(partnerName)}
      value={partnerName}
      variant={boosted ? 'plain' : 'radio'}
      minw={40}
      onClick={handleClick}
      selected={partnerName === selected}
      content={
        <Box flex column mt={8}>
          <Text color="mono700" noWrap>
            {boosted
              ? 'Already boosted'
              : `Get up 8 times more quality candidates • $${price}/boost`}
          </Text>
        </Box>
      }
      leftContent={leftContent || null}
    />
  );
}

export default withUxRoot({
  productArea: PRODUCT_AREAS.HIRING,
  eventCategory: EVENT_CATEGORIES.HIRING_DASHBOARD,
})(TransactionWidget);
